import * as PollApi from '../api/pollApi';
import { getQueryParameters } from '../util/utils';

export const RECEIVE_POLL = 'RECEIVE_POLL';
export const RECEIVE_POLL_VOTES = 'RECEIVE_POLL_VOTES';
export const RECEIVE_POLL_RESULTS = 'RECEIVE_POLL_RESULTS';
export const RECEIVE_POLL_VOTE_REGISTRATION = 'RECEIVE_POLL_VOTE_REGISTRATION';

export const receivePoll = (poll) => ({
    type: RECEIVE_POLL,
    poll
});

export const receiveVotes = (votes) => ({
    type: RECEIVE_POLL_VOTES,
    votes
});

export const receiveResults = (results) => ({
    type: RECEIVE_POLL_RESULTS,
    results
});

export const receiveVoteRegistration = (registered) => ({
    type: RECEIVE_POLL_VOTE_REGISTRATION,
    registered
});

export const fetchPoll = (pollId) => dispatch => {
    //TODO: Temporary feature flag to toggle site styling. Remove after testing
    const hrefParts = window.location.href.split("?");
    const queryStr = '?' + hrefParts[hrefParts.length - 1];
    const testSiteParam = getQueryParameters(queryStr).site || 'hl';

    return PollApi.fetchPoll(pollId, testSiteParam)
        .then(res => {
            dispatch(receivePoll(res.data));
        });
};

export const fetchVotes = (pollId) => dispatch => {
    return PollApi.fetchVotes(pollId)
        .then(res => {
            dispatch(receiveVotes(res.data));
        });
};

export const fetchResults = (pollId) => dispatch => {
    return PollApi.fetchResults(pollId)
        .then(res => {
            dispatch(receiveResults(res.data));
        });
};

export const registerVote = (pollOptionId) => dispatch => {
    console.log("registering vote");
    
    return PollApi.registerVote(pollOptionId)
        .then(res => {
            dispatch(receiveVoteRegistration(!!res));
        });
};